import { FC, Fragment } from 'react'
import { Field } from 'formik'
import { StyleFormWrapper, StyleLabel } from '../style'
import {
  StyleGroupRadioItems,
  StyleGroupRadioItem,
  StyleRadio,
  StyleRadioLabel,
} from './style'
import ErrorMessage from '../ErrorMessage'
interface GroupRadioProps {
  name: string
  label?: string
  options: Array<any>
  valueAsKey: string
  titleAsKey: string
  styleWrapper?: string
  styleLabel?: string
}
const GroupRadio: FC<GroupRadioProps> = ({
  label,
  name,
  options,
  styleWrapper,
  styleLabel,
  valueAsKey,
  titleAsKey,
}) => {
  const handleCheckboxChange = ({ e, field, form }: any) => {
    const value = e.target.value
    if (!value) return
    form.setFieldValue(name, value)
  }
  return (
    <Field name={name} styleWrapper={styleWrapper}>
      {({ field, meta, form }) => {
        const hasError = meta.touched && meta.error
        return (
          <StyleFormWrapper styleWrapper={styleWrapper}>
            {!!label && (
              <StyleLabel hasError={hasError} styleLabel={styleLabel}>
                {label}
              </StyleLabel>
            )}
            <StyleGroupRadioItems
              onChange={(e: any) => {
                handleCheckboxChange({
                  e,
                  field,
                  form,
                })
              }}
            >
              {options?.map((option, index) => {
                return (
                  <Fragment key={index}>
                    <StyleGroupRadioItem>
                      <StyleRadio
                        type="radio"
                        value={option[valueAsKey]}
                        checked={field.value?.includes(option[valueAsKey])}
                        readOnly
                      />
                      <StyleRadioLabel>{option[titleAsKey]}</StyleRadioLabel>
                    </StyleGroupRadioItem>
                  </Fragment>
                )
              })}
            </StyleGroupRadioItems>
            {!!hasError && <ErrorMessage message={meta.error} />}
          </StyleFormWrapper>
        )
      }}
    </Field>
  )
}

export default GroupRadio
